import React from 'react';
import './index.sass';

const Footer = () => {
    return (
        <footer className="Footer">
            <div className="container Footer__Container">
                <div className="Footer__Top">
                    <a className="Footer__Brand" href="/">
                        <span className="Footer__Brand-Mark">СП</span>
                        <span className="Footer__Brand-Text">Смарт&nbsp;СП</span>
                    </a>
                    <p className="Footer__Tagline">
                        Создаём и сопровождаем сложные информационные системы
                        для банков, госсектора и крупной индустрии.
                    </p>
                </div>
                <div className="Footer__Bottom">
                    <span className="Footer__Copyright">
                        © 2012–2026 ООО «Смарт СП». Все права защищены.
                    </span>
                    <a className="Footer__Email" href="mailto:info@smartsp.ru">info@smartsp.ru</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
